import type { ScoringResult } from '@mathflat/domain/Scoring'
import type { GroupWorksheetScoring } from '@mathflat/domain/StudentWorksheet'
import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'

import { typeSafeAssign } from '@/utils/common'

export class ProblemScoring extends UndoableDTO {
  worksheetProblemId: number = EMPTY_NUMBER_ID
  result: ScoringResult = 'CORRECT'
  virtualResult: ScoringResult = 'NONE'
  /** 서버 원본이 아니라 다중 셀(userAnswers)까지 합친 표시용 KaTeX 문자열(formatSubmittedAnswer) */
  virtualUserAnswer: string = ''

  constructor(
    data?: Pick<GroupWorksheetScoring['scoringList'][number], 'worksheetProblemId' | 'result'> & {
      virtualResult: ScoringResult
      virtualUserAnswer: string
    },
  ) {
    super()
    makeObservable(this, {
      worksheetProblemId: observable,
      result: observable,
      virtualResult: observable,
      virtualUserAnswer: observable,
    })

    if (data) typeSafeAssign(this, data)
  }
}
